import type { Attachment, Message } from './types';

export interface RealtimeAttachmentDto {
  storageKey: string;
  contentType: string;
  sizeBytes: number;
  originalName?: string;
}

export interface RealtimeMessageDto {
  id: string;
  conversationId: string;
  senderType: Message['role'];
  senderId: string | null;
  content: string;
  attachments: RealtimeAttachmentDto[];
  isInternal: boolean;
  createdAt: string;
}

export interface RealtimeChatMessageEvent {
  conversationId: string;
  message: RealtimeMessageDto;
}

export function mapRealtimeAttachment(dto: RealtimeAttachmentDto): Attachment {
  return {
    storage_key: dto.storageKey,
    content_type: dto.contentType,
    size_bytes: dto.sizeBytes,
    original_name: dto.originalName,
  };
}

export function mapRealtimeMessageEvent(event: RealtimeChatMessageEvent): {
  conversationId: string;
  message: Message;
} {
  return {
    conversationId: event.conversationId,
    message: {
      id: event.message.id,
      role: event.message.senderType,
      text: event.message.content,
      attachments: event.message.attachments.map(mapRealtimeAttachment),
      created_at: event.message.createdAt,
    },
  };
}